import React from 'react';
import { Check, X } from 'lucide-react';
export function TransformSection() {
  return <section className="py-20 px-4 bg-[#F2F1EE]" data-id="element-209">
      <div className="max-w-5xl mx-auto" data-id="element-210">
        {/* Benefits */}
        <div className="text-center mb-20" data-id="element-211">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-12 text-[#DF1189]" data-id="element-212">
            Lo que cambia en tu semana
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8" data-id="element-213">
            <div className="p-6 bg-white rounded-2xl shadow-sm" data-id="element-214">
              <p className="text-4xl mb-4" data-id="element-215">😌</p>
              <h3 className="font-bold text-lg mb-2 text-charcoal" data-id="element-216">
                Menos estrés
              </h3>
              <p className="text-charcoal-light" data-id="element-217">
                Menos "¿qué hago hoy?" y menos picoteo por cansancio.
              </p>
            </div>
            <div className="p-6 bg-white rounded-2xl shadow-sm" data-id="element-218">
              <p className="text-4xl mb-4" data-id="element-219">💪</p>
              <h3 className="font-bold text-lg mb-2 text-charcoal" data-id="element-220">
                Más energía
              </h3>
              <p className="text-charcoal-light" data-id="element-221">
                Más proteína real sin sentirte a dieta estricta.
              </p>
            </div>
            <div className="p-6 bg-white rounded-2xl shadow-sm" data-id="element-222">
              <p className="text-4xl mb-4" data-id="element-223">🕊️</p>
              <h3 className="font-bold text-lg mb-2 text-charcoal" data-id="element-224">Más paz</h3>
              <p className="text-charcoal-light" data-id="element-225">
                Más control sin sentirte rígida. Tu comida deja de ser un
                problema.
              </p>
            </div>
          </div>
        </div>

        {/* Who is this for */}
        <div className="grid md:grid-cols-2 gap-8" data-id="element-226">
          {/* For You */}
          <div className="bg-olive/5 p-8 rounded-3xl border border-olive/10" data-id="element-227">
            <h3 className="text-2xl font-serif font-bold text-olive mb-6 flex items-center gap-3" data-id="element-228">
              <Check className="w-6 h-6" data-id="element-229" /> Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-230">
              <li className="flex items-start gap-3" data-id="element-231">
                <Check className="w-5 h-5 text-olive mt-0.5" data-id="element-232" />
                <span className="text-charcoal" data-id="element-233">
                  Tienes freidora de aire (o planeas usarla)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-234">
                <Check className="w-5 h-5 text-olive mt-0.5" data-id="element-235" />
                <span className="text-charcoal" data-id="element-236">
                  Quieres comidas rápidas, repetibles y con sabor
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-237">
                <Check className="w-5 h-5 text-olive mt-0.5" data-id="element-238" />
                <span className="text-charcoal" data-id="element-239">
                  Te sirve seguir un menú y listas sin pensar
                </span>
              </li>
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-charcoal/5 p-8 rounded-3xl border border-charcoal/10" data-id="element-240">
            <h3 className="text-2xl font-serif font-bold text-charcoal-light mb-6 flex items-center gap-3" data-id="element-241">
              <X className="w-6 h-6" data-id="element-242" /> No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-243">
              <li className="flex items-start gap-3" data-id="element-244">
                <X className="w-5 h-5 text-charcoal-light mt-0.5" data-id="element-245" />
                <span className="text-charcoal-light" data-id="element-246">
                  Buscas cocina gourmet complicada
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-247">
                <X className="w-5 h-5 text-charcoal-light mt-0.5" data-id="element-248" />
                <span className="text-charcoal-light" data-id="element-249">
                  Quieres recetas nuevas cada día
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-250">
                <X className="w-5 h-5 text-charcoal-light mt-0.5" data-id="element-251" />
                <span className="text-charcoal-light" data-id="element-252">
                  No estás dispuesta a invertir 25 min dos veces por semana
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}